import { setDefaultLessonVersion } from "api/services/lesson-service";
import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";

export const useSetDefaultVersion = () => {
    const { callAPI, loading } = useWorkspaceApiCall(
        setDefaultLessonVersion,
        'setDefaultVersion.success',
        'setDefaultVersion.error'
    );

    return {
        setDefaultVersion: callAPI,
        setting: loading
    };
};